import { memo } from 'react';

import { Spin } from 'antd';
import styled from 'styled-components';
import { theme } from 'theme/theme';

// interface LoadingProps {
//   // type: 'drawer-skeleton' | 'table-skeleton' | 'form-skeleton'
// }
// Here we are going to add the skeletons

const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;
  height: -webkit-fill-available;  /* Mozilla-based browsers will ignore this. */
  height: inherit;
  
  .ant-spin-dot-item {
    background-color: ${theme.colors.greenMain};
  }
`;

function Loading() {
  return <Container><Spin /></Container>;
}

export default memo(Loading);
